import Highcharts from "highcharts";
import { HighchartsReact } from "highcharts-react-official";
import React, { useState } from "react";
import { useEffect } from "react";
import { useSelector } from "react-redux";

const Highchart = (props) => {
  const [options, setOptions] = useState({});
  const darkMode = useSelector((data) => data.hamberger.darkModeState);
  useEffect(() => {
    // const data = JSON.parse(localStorage.getItem("home_admin_data"));
    // console.log(data)
    const theme = localStorage.getItem("theme");
    let object = { theme };
    if (theme === "light" || theme === "undefined") {
      object = {
        chart: {
          backgroundColor: "#fff",
          polar: true,
          type: "line",
        },
        title: {
          text: "نمودار اطلاعات 30 روز گذشته",
          align: "center",
          style: {
            color: "#1d212f",
          },
        },
        colors: [
          "#2caffe",
          "#00e272",
          "#544fc5",
          "#fe6a35",
          "#6b8abc",
          "#d90000",
        ],
        yAxis: {
          labels: {
            style: {
              color: "#8f8fb1",
            },
          },
          title: {
            text: "تعداد",
            style: {
              color: "#1d212f",
            },
          },
        },
        xAxis: {
          labels: {
            style: {
              color: "#8f8fb1",
            },
          },
          categories: [],
        },
        legend: {
          layout: "vertical",
          align: "right",
          verticalAlign: "middle",
          itemStyle: {
            color: "#1d212f",
          },
        },
        plotOptions: {
          line: {
            dataLabels: {
              enabled: false,
            },
            enableMouseTracking: true,
          },
        },
        series: [],
        responsive: {
          rules: [
            {
              condition: {
                maxWidth: 500,
              },
              chartOptions: {
                legend: {
                  layout: "horizontal",
                  align: "center",
                  verticalAlign: "bottom",
                },
              },
            },
          ],
        },
      };
    } else {
      object = {
        chart: {
          backgroundColor: "#29435C",
          polar: true,
          type: "line",
        },
        title: {
          text: "نمودار اطلاعات 30 روز گذشته",
          align: "center",
          style: {
            color: "#D1D4C9",
          },
        },
        colors: [
          "#00fffb",
          "#1aff00",
          "#cc00ff",
          "#ffa600",
          "#fbff00",
          "#ff0000",
        ],
        yAxis: {
          labels: {
            style: {
              color: "#D1D4C9",
            },
          },
          title: {
            text: "تعداد",
            style: {
              color: "#D1D4C9",
            },
          },
        },
        xAxis: {
          labels: {
            style: {
              color: "#D1D4C9",
            },
          },
          categories: [],
        },
        legend: {
          layout: "vertical",
          align: "right",
          verticalAlign: "middle",
          itemStyle: {
            color: "#D1D4C9",
          },
        },
        plotOptions: {
          line: {
            dataLabels: {
              enabled: false,
            },
            enableMouseTracking: true,
          },
        },
        series: [],
        responsive: {
          rules: [
            {
              condition: {
                maxWidth: 500,
              },
              chartOptions: {
                legend: {
                  layout: "horizontal",
                  align: "center",
                  verticalAlign: "bottom",
                },
              },
            },
          ],
        },
      };
    }
    object.xAxis.categories = props.dashboardData && props.dashboardData.labels;
    object.series = props.dashboardData && props.dashboardData.series;
    setOptions(object);
  }, [darkMode, props]);

  return (
    <div className="dark:bg-[#29435C]">
      <HighchartsReact highcharts={Highcharts} options={options} />
    </div>
  );
};

export default Highchart;
